import React from 'react';
import { connect } from 'react-redux';
import UnlockPremium from './UnlockPremium'
import { Modal } from 'antd';

import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect
} from 'react-router-dom'

import { push, goBack } from 'react-router-redux'

const UnlockPremiumModal = ({ dispatch }) => (
  <Modal
    bodyStyle={{padding: 0}}
    visible={true}
    // onOk={this.handleOk}
    onCancel={() => dispatch({type:'HIDE_MODAL_2'})}
    footer={null}
  >
    <UnlockPremium goToPremium={()=>{
      dispatch(push('/premium'))
      dispatch({type:'HIDE_MODAL_2'})
    }} cancel={() => dispatch({type:'HIDE_MODAL_2'})}/>

  </Modal>

)

export default connect(
  // ownProps in this case are modalProps passed from the action or reducer
  (state, ownProps) => ({

  })
)(UnlockPremiumModal)



// WEBPACK FOOTER //
// ./src/modal/UnlockPremiumModal.js